var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXButtonGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6462 10.9395L11.9997 11.2931L12.3533 10.9395L16.9497 6.34309L17.6566 7.04999L13.0602 11.6464L12.7066 12L13.0602 12.3535L17.6566 16.95L16.9497 17.6569L12.3533 13.0604L11.9997 12.7069L11.6462 13.0604L7.04974 17.6569L6.34285 16.95L10.9393 12.3535L11.2928 12L10.9393 11.6464L6.34285 7.04999L7.04974 6.34309L11.6462 10.9395Z",
    fill: "#8D96B2",
    stroke: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXButtonGrey);
export default __webpack_public_path__ + "static/media/xButtonGrey.0a2dc15f3c74ccea5383bd85320f1410.svg";
export { ForwardRef as ReactComponent };